import { Alert, Form } from 'react-bootstrap';
import moment from 'moment';

import { PraSection } from '../../../../../../__gqltypes__';
import { PRA_CONFIG_CHANGE_NOTICE } from '../utils';

type Props = {
  section: PraSection;
  configExists: boolean;
  maintenance: boolean;
  maintenanceSince?: Date | string | number | null;
  saving: boolean;
  onToggle: (enabled: boolean) => void;
};

// Per-section maintenance switch (split per section, D13). Optional while editing — the D8 safe-to-edit
// waiting rule and its countdown are gone; the panel only shows since when maintenance is ON and what
// players experience meanwhile.
export function PraMaintenancePanel({
  section,
  configExists,
  maintenance,
  maintenanceSince,
  saving,
  onToggle,
}: Props): JSX.Element {
  return (
    <Form.Group>
      <Form.Check
        type="switch"
        id={`pra-maintenance-${section}`}
        label="Maintenance mode (optional while editing — players without an active cycle see the maintenance screen until you turn it off; mid-cycle players finish on their snapshot)"
        checked={maintenance}
        disabled={!configExists || saving}
        onChange={(e) => onToggle(e.target.checked)}
      />
      {!configExists && (
        <Form.Text className="text-muted">Save this section once to enable the maintenance switch.</Form.Text>
      )}
      {maintenance && (
        <Alert variant="info" className="mt-2 mb-0">
          <div>
            Maintenance since:{' '}
            <strong>{maintenanceSince != null ? moment(maintenanceSince).format('YYYY-MM-DD HH:mm:ss') : '—'}</strong>
          </div>
          <div className="mt-2">{PRA_CONFIG_CHANGE_NOTICE}</div>
        </Alert>
      )}
    </Form.Group>
  );
}
